import * as Styled from '../Breadcrumb.styles';
import { RenderPathFn } from '../Breadcrumb.types';

export const defaultRenderPath: RenderPathFn = (path, name, icon, iconPosition, isLast) => (
  <Styled.BreadcrumbItem
    iconPosition={iconPosition}
    href={path || undefined}
    tabIndex={!path ? 0 : undefined}
    aria-current={isLast ? 'page' : undefined}
  >
    {icon} {name}
  </Styled.BreadcrumbItem>
);
